var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWishlist24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12 22.25-1.366-1.48C5.564 15.895 2.25 12.608 2.25 8.577c0-3.28 2.342-5.827 5.36-5.827 1.662 0 3.319.85 4.39 2.226 1.071-1.377 2.728-2.226 4.39-2.226 3.018 0 5.36 2.546 5.36 5.827 0 4.031-3.314 7.318-8.384 12.193z",
  clipRule: "evenodd"
})));
export { SvgWishlist24Px as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvd2lzaGxpc3QyNHB4LjAwMGE5MGQ2LnN2ZyI7";